import { render, staticRenderFns } from "./bottomNav.vue?vue&type=template&id=79e6c1fc&scoped=true&"
import script from "./bottomNav.vue?vue&type=script&lang=js&"
export * from "./bottomNav.vue?vue&type=script&lang=js&"
import style0 from "./bottomNav.vue?vue&type=style&index=0&id=79e6c1fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e6c1fc",
  null
  
)

export default component.exports